import React from 'react'
import { Link } from 'react-router-dom'

const Inarticle = () => {
  return (
    <div>
     <section class="text-gray-600 body-font">
  <div class="container px-5 py-24 mx-auto flex flex-col">
    <div class="lg:w-4/6 mx-auto">
      <div class="rounded-lg h-64 overflow-hidden">
        <img alt="content" class="object-cover object-center h-full w-full" src="https://www.samaa.tv/images/psl-9-auction-broadcasting.jpg"/>
      </div>
      <div class="flex flex-col sm:flex-row mt-10">
        <div class="sm:w-1/3 text-center sm:pr-8 sm:py-8">
          <div class="w-20 h-20 rounded-full inline-flex items-center justify-center bg-gray-200 text-gray-400">
         <img alt="content" class="object-cover object-center h-full w-full" src="https://scontent.flhe7-2.fna.fbcdn.net/v/t39.30808-6/360103032_679447757532813_3320949709480004465_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=r5uznND0uv0AX9o5MFx&_nc_ht=scontent.flhe7-2.fna&oh=00_AfABv2dPzf0sClaYmPqKw6WJ81AapOLeyTfU4khccrUqtw&oe=65A55399" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"/>
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            
          </div>
          <div class="flex flex-col items-center text-center justify-center">
            <h2 class="font-medium title-font mt-4 text-gray-900 text-lg">AJ-CRICKET</h2>
            <div class="w-12 h-1 bg-green-500 rounded mt-2 mb-4"></div>
            <p class="text-base">Aj Cricket is a Platfrom where you can enjoy different things and get updates from latest news</p>
          </div>
        </div>
        <div class="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-200 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left">
          <p class="leading-relaxed text-lg mb-4">2024 Pakistan Super League (also known as PSL 9 or, for sponsorship reasons, HBL PSL 2024) will be the ninth season of the Pakistan Super League, a franchise Twenty20 cricket league which was established by the Pakistan Cricket Board (PCB) in 2015. It will be contested among six teams in February and March 2024 The Pakistan Super League (PSL) (also known as the HBL PSL for sponsorship reasons) is a men's Twenty20 cricket league contested by six city-based franchise teams. The league was founded in 2015 by the Pakistan Cricket Board. Instead of operating as an association of independently owned teams, the league is a single entity in which each franchise is owned and controlled by investors.

Each team plays the group stage matches in a double round robin format and the top four teams with the most points qualify for the playoffs, culminating in the final.

There have been eight seasons of the league. Islamabad United and Lahore Qalandars being the only teams to have won the title twice, are the most successful teams. The current champions Lahore Qalandars are the only team to successfully defend its title, after winning in the 2023 season.
  <br/> <p class="font-bold"> PSL 9 Schedule </p>
  <br/>Feb 17: Qalandars vs United in Lahore

  <br/>Feb 18: Gladiators vs Zalmi in Lahore and Sultans vs Kings in Multan


  <br/>Feb 19: Qalandars vs Gladiators in Lahore

  <br/>Feb 20: Sultans vs United in Multan

  <br/>Feb 21: Zalmi vs Kings in Lahore and Sultans vs Qalandars in Multan

  <br/>Feb 22: Gladiators vs United in Lahore

  <br/>Feb 23: Sultans vs Zalmi in Multan

  <br/>Feb 24: Qalandars vs Kings in Lahore

  <br/>Feb 25: Sultans vs Gladiators in Multan and Qalandars vs Zalmi in Lahore

  <br/>Feb 26: Zalmi vs United in Lahore

  <br/>Feb 27: Qalandars vs Sultans in Lahore

  <br/>Feb 28: Kings vs United in Karachi

  <br/>Feb 29: Rest day

  <br/>Mar 1: Zalmi vs Qalandars and United vs Gladiators in Pindi

  <br/>Mar 2: Kings vs Sultans in Karachi

  <br/>Mar 3: United vs Zalmi in Pindi

  <br/>Mar 4: Kings vs Gladiators in Karachi

  <br/>Mar 5: Zalmi vs Sultans in Pindi

  <br/>Mar 6: United vs Qalandars and Gladiators vs Kings in Pindi

  <br/>Mar 7: United vs Kings in Pindi

  <br/>Mar 8: Zalmi vs Gladiators in Pindi

  <br/>Mar 9: Kings vs Qalandars in Karachi

  <br/>Mar 10: United vs Sultans and Gladiators vs Qalandars in Pindi

  <br/>Mar 11: Kings vs Zalmi in Karachi

  <br/>Mar 12: Gladiators vs Sultans in Karachi

  <br/>Mar 13: Rest day

  <br/>Mar 14: Qualifier (Team 1 vs Team 2) and Eliminator 1 (Team 3 vs Team 4) in Karachi

  <br/>Mar 15: Eliminator 2 (Eliminator winner vs Qualifer runner-up) in Karachi

  <br/>Mar 16: Rest day

  <br/>Mar 17: Final in Karachi 

</p>
          <  Link to='/article' class="text-green-500 inline-flex items-center">Allah Hafiz
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
  )
}

export default Inarticle
